/* eslint-disable jsx-a11y/label-has-associated-control */
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Download } from "react-feather";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { Col, Form, FormGroup, Row } from "reactstrap";
import styled from "styled-components";
import * as Yup from "yup";
import { BlurSpinner } from "../../components/BlurSpinner";
import FileUploader from "../../components/FileUploader";
import { handleClickFile } from "../../components/RelevosInfoGeneral/utils";
import SelectV2 from "../../components/SelectV2";
import TicketZoneSelector from "../../components/TicketZoneSelector";
import CreateTicketInBehalf from "../../components/TicketZoneSelector/createInBehalf";
import { useAuth } from "../../context/AuthContext";
import useFetcher from "../../hooks/useFetcher";
import { useFiles } from "../../hooks/useFiles";
import { getCategories } from "../../services/ExcepcionesContratosServices";
import { getSubmotivoFile } from "../../services/fileServices";
import { handleErrors } from "../../services/handleErrors";
import { fetchRegiones } from "../../services/regionServices";
import { fetchSucursales } from "../../services/sucursalServices";
import { postTicketing, postTicketingOnBehalf } from "../../services/ticketingServices";
import { ButtonPrimary, ButtonSecondaryV2, StyledSpinnerButton } from "../../ui/buttons";
import { InputText, InputTextAreaEditorContainer } from "../../ui/inputs";
import { CustomLabel, ErrorFeedback } from "../../ui/labels";
import { retriveRegionSucursalOptions } from "../../utils/retriveRegionSucursalOptions";
import { CustomToolBarGroup } from "../TicketDetail/Inbox/styles";

const TextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #f7f7f7;
  border-radius: 8px;
`;

const AvisoContainer = styled.div.withConfig({ shouldForwardProp: (prop) => prop !== "color" })`
  background-color: #f7f7f7;
  border: 1px solid #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  text-align: center;
  color: #5b5b5b;
`;

const TicketingNew = ({ toggle, reloadTickets }) => {
  const { refreshToken, currentUser } = useAuth();
  const [categories, isLoadingCategories] = useFetcher(getCategories, undefined, "getCategories");
  const [isLoadingEditor, setIsLoadingEditor] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [, , saveFiles] = useFiles();
  const [spinnerState, setSpinnerState] = useState(true);
  const [userToCreateTicket, setUserToCreateTicket] = useState("");
  const [isOnBehalf, setisOnBehalf] = useState(false);
  const [disclaimer, setDisclaimer] = useState("");
  const [isSubmotivoFileLoading, setIsSubmotivoFileLoading] = useState(false);
  const [submotivoSelected, setSubmotivoSelected] = useState(null);
  const [contratoForm, setContratoForm] = useState(null);
  const [excepcionForm, setExcepcionForm] = useState(null);
  const [regiones, isLoadingRegiones] = useFetcher(fetchRegiones, undefined, "fetchRegiones");
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursales, undefined, "fetchSucursales");
  const [regionValue, setRegionValue] = useState(null);
  const [sucursalValue, setSucursalValue] = useState(null);

  // se pasa un array vacio para eliminar del select las sucursales de casa central
  const casasCentralesVacio = [];

  // se elimina la region CASA CENTRAL por defecto de las regiones
  const regionesFiltered = regiones.filter((r) => r.title !== "CASA CENTRAL");

  const helperRegionSucursal = retriveRegionSucursalOptions(
    regionValue && regionValue.value,
    sucursalValue && sucursalValue.value,
    regionesFiltered,
    sucursales,
    casasCentralesVacio,
    isLoadingRegiones || isLoadingSucursales
  );

  const tipoDeServiciosContratosOptions =
    categories &&
    categories.tipoServicioContratos &&
    categories.tipoServicioContratos.map((item) => {
      return { value: item.id, label: item.name };
    });

  const tipoDeServiciosExcepcionOptions =
    categories &&
    categories.tipoServicioExcepciones &&
    categories.tipoServicioExcepciones.map((item) => {
      return { value: item.id, label: item.name };
    });

  const tiposDeDocumentosOptions =
    categories &&
    categories.tipoDocumento &&
    categories.tipoDocumento.map((item) => {
      return { value: item.id, label: item.name };
    });

  const motivosDeExcepcionOptions =
    categories &&
    categories.motivoExcepcion &&
    categories.motivoExcepcion.map((item) => {
      return { value: item.id, label: item.name };
    });

  const handleConfirmSelectedFiles = (event) => {
    setSelectedFiles(event.target.files);
  };

  const ticketZoneMount = () => {
    setSpinnerState(false);
  };

  const handleSetOnBehalf = () => {
    setisOnBehalf(!isOnBehalf);
  };

  function getFunctionToFilter(filter, selected) {
    // contrato
    if (filter === "tipoDeServicioContrato") {
      setContratoForm({
        ...contratoForm,
        tipoDeServicio: (selected && selected.value) || null,
      });
    }
    if (filter === "tipoDeDocumento") {
      setContratoForm({
        ...contratoForm,
        tipoDeDocumento: (selected && selected.value) || null,
      });
    }

    if (filter === "sucursalContrato") {
      setSucursalValue(selected);
      setContratoForm({
        ...contratoForm,
        sucursal: (selected && selected.value) || null,
      });
    }

    if (filter === "regionContrato") {
      setRegionValue(selected);
    }

    // excepcion
    if (filter === "tipoDeServicioExcepcion") {
      setExcepcionForm({
        ...excepcionForm,
        tipoDeServicio: (selected && selected.value) || null,
      });
    }
    if (filter === "motivoDeExcepcion") {
      setExcepcionForm({
        ...excepcionForm,
        motivoDeExcepcion: (selected && selected.value) || null,
      });
    }

    if (filter === "sucursalExcepcion") {
      setSucursalValue(selected);
      setExcepcionForm({
        ...excepcionForm,
        sucursal: (selected && selected.value) || null,
      });
    }

    if (filter === "regionExcepcion") {
      setRegionValue(selected);
    }
  }
  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const inputError = () => {
    const error = { error: false };

    // contratos
    if (contratoForm && contratoForm.cliente === null) {
      error.cliente = "Este campo es obligatorio.";
      error.error = true;
    } else if ((contratoForm && contratoForm.cliente === "") || (contratoForm && contratoForm.cliente === undefined)) {
      error.cliente = "Este campo es obligatorio.";
      error.error = true;
    }

    if (contratoForm && contratoForm.tipoDeServicio === null) {
      error.tipoDeServicioContrato = "Este campo es obligatorio.";
      error.error = true;
    } else if ((contratoForm && contratoForm.tipoDeServicio === "") || (contratoForm && contratoForm.tipoDeServicio === undefined)) {
      error.tipoDeServicioContrato = "Este campo es obligatorio.";
      error.error = true;
    }

    if (contratoForm && contratoForm.tipoDeDocumento === null) {
      error.tipoDeDocumento = "Este campo es obligatorio.";
      error.error = true;
    } else if ((contratoForm && contratoForm.tipoDeDocumento === "") || (contratoForm && contratoForm.tipoDeDocumento === undefined)) {
      error.tipoDeDocumento = "Este campo es obligatorio.";
      error.error = true;
    }

    if (contratoForm && contratoForm.sucursal === null) {
      error.sucursalContrato = "Este campo es obligatorio.";
      error.error = true;
    } else if ((contratoForm && contratoForm.sucursal === "") || (contratoForm && contratoForm.sucursal === undefined)) {
      error.sucursalContrato = "Este campo es obligatorio.";
      error.error = true;
    }

    // excepcion
    if (excepcionForm && excepcionForm.tipoDeServicio === null) {
      error.tipoDeServicioExcepcion = "Este campo es obligatorio.";
      error.error = true;
    } else if ((excepcionForm && excepcionForm.tipoDeServicio === "") || (excepcionForm && excepcionForm.tipoDeServicio === undefined)) {
      error.tipoDeServicioExcepcion = "Este campo es obligatorio.";
      error.error = true;
    }

    if (excepcionForm && excepcionForm.motivoDeExcepcion === null) {
      error.motivoDeExcepcion = "Este campo es obligatorio.";
      error.error = true;
    } else if ((excepcionForm && excepcionForm.motivoDeExcepcion === "") || (excepcionForm && excepcionForm.motivoDeExcepcion === undefined)) {
      error.motivoDeExcepcion = "Este campo es obligatorio.";
      error.error = true;
    }

    if (excepcionForm && excepcionForm.sucursal === null) {
      error.sucursalExcepcion = "Este campo es obligatorio.";
      error.error = true;
    } else if ((excepcionForm && excepcionForm.sucursal === "") || (excepcionForm && excepcionForm.sucursal === undefined)) {
      error.sucursalExcepcion = "Este campo es obligatorio.";
      error.error = true;
    }

    return error;
  };

  const messageError = inputError();

  const setFieldsTouched = (formik) => {
    if (submotivoSelected === "contrato") {
      formik.setTouched({
        cliente: true,
        tipoDeServicioContrato: true,
        tipoDeDocumento: true,
        sucursalContrato: true,
      });
    }

    if (submotivoSelected === "excepcion") {
      formik.setTouched({
        tipoDeServicioExcepcion: true,
        motivoDeExcepcion: true,
        sucursalExcepcion: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      asignacion2: null,
      sucursaldepartamentoAsignado: null,
      motivo: null,
      submotivo: null,
      solicitud: "",
      categoria: null,
      nombre: "",
      apellido: "",
      email: "",
      piAsignado: null,

      cliente: "",
      tipoDeServicioContrato: "",
      tipoDeDocumento: "",
      sucursalContrato: "",

      tipoDeServicioExcepcion: "",
      motivoDeExcepcion: "",
      sucursalExcepcion: "",
    },
    onSubmit: async (_ticket) => {
      const ticket = { ..._ticket };
      setFieldsTouched(formik);
      if (messageError.error) {
        return;
      }
      formik.setSubmitting(true);

      if (submotivoSelected === "contrato") {
        const dataToCreateContrato = {
          cliente: contratoForm.cliente,
          tipoDeServicio: contratoForm.tipoDeServicio,
          tipoDeDocumento: contratoForm.tipoDeDocumento,
          sucursal: contratoForm.sucursal,
        };
        ticket.contrato = dataToCreateContrato;
      }
      if (submotivoSelected === "excepcion") {
        const dataToCreateExcepcion = {
          tipoDeServicio: excepcionForm.tipoDeServicio,
          motivoDeExcepcion: excepcionForm.motivoDeExcepcion,
          sucursal: excepcionForm.sucursal,
        };
        ticket.excepcion = dataToCreateExcepcion;
      }
      try {
        const { message, result } = isOnBehalf ? await postTicketingOnBehalf(ticket) : await postTicketing(ticket);
        if (selectedFiles.length > 0) {
          const dataFiles = {
            entity: result.solicitudMessageId ? "message" : "ticketing",
            entityId: result.solicitudMessageId || result.ticket.itemId,
            files: selectedFiles,
          };
          if (["contrato", "excepcion"].includes(submotivoSelected)) {
            dataFiles.legales = { type: submotivoSelected, id: result.legalesItemId };
          }
          try {
            await saveFiles(dataFiles);
          } catch (error) {
            let errMsg = "";
            handleErrors(
              error,
              (msg) => {
                errMsg = msg;
              },
              refreshToken,
              formik
            );
            toast.error(`Error subiendo los archivos, intente luego desde el detalle del ticket. ${errMsg}`);
          }
        }

        toast.success(message);
        formik.resetForm();
        setSelectedFiles([]);
        toggle();
        reloadTickets();
      } catch (error) {
        handleErrors(error, toast.error, refreshToken, formik);
      }
    },
    validationSchema: Yup.object().shape({
      asignacion2: Yup.number().typeError("Debe seleccionar un sector de la lista").required("Este campo es requerido."),
      sucursaldepartamentoAsignado: Yup.mixed().when("asignacion2", (asignacion2) => {
        if (asignacion2 === 1) {
          return Yup.number().typeError("Debe seleccionar un departamento de la lista").required("Este campo es requerido.");
        }
        if (asignacion2 === 2) {
          return Yup.number().typeError("Debe seleccionar una sucursal de la lista").required("Este campo es requerido.");
        }
        return Yup.mixed().required("Este campo es requerido.");
      }),
      motivo: Yup.number().typeError("Debe seleccionar un motivo de la lista").required("Este campo es requerido."),
      submotivo: Yup.number().typeError("Debe seleccionar un sub motivo de la lista").required("Este campo es requerido."),
      solicitud: Yup.string().required("Este campo es requerido."),
      piAsignado: Yup.number().nullable().optional(),
      categoria: Yup.mixed().when(() => {
        if (isOnBehalf) {
          return Yup.number().typeError("Debe seleccionar un publico").required("Este campo es requerido.");
        }
        return Yup.number().nullable().optional();
      }),
      nombre: Yup.mixed().when(() => {
        if (isOnBehalf && formik.values.piAsignado === null) {
          return Yup.string().typeError("Debe completar el nombre.").required("Este campo es requerido.");
        }
        return Yup.string();
      }),
      apellido: Yup.mixed().when(() => {
        if (isOnBehalf && formik.values.piAsignado === null) {
          return Yup.string().typeError("Debe completar el apellido.").required("Este campo es requerido.");
        }
        return Yup.string();
      }),
      dniCreador: Yup.mixed().when("categoria", (categoria) => {
        if (isOnBehalf && categoria === 1) {
          return Yup.number().typeError("Debe completar el DNI.").required("Este campo es requerido.");
        }
        return Yup.number();
      }),
      email: Yup.mixed().when(() => {
        if (isOnBehalf && formik.values.piAsignado === null) {
          return Yup.string().typeError("Debe completar el email.").required("Este campo es requerido.");
        }
        return Yup.string();
      }),
      telefonoCreador: Yup.mixed().when((telefonoCreador) => {
        if (isOnBehalf && telefonoCreador !== "null") {
          return Yup.number();
        }
        return Yup.number();
      }),
    }),
  });

  useEffect(() => {
    if (currentUser) {
      const user = `${currentUser.user.nombre} ${currentUser.user.apellido}`;
      setUserToCreateTicket(user);
    }
  }, []);

  // segun el submotivo seleccionado puede mostrar el form para contrato o excepcion
  useEffect(() => {
    if (formik.values.submotivo) {
      if (formik.values.submotivo === 2156275377 || formik.values.submotivo === 2736088919) {
        setSubmotivoSelected("contrato");
        setExcepcionForm(null);
        if (!contratoForm) {
          setContratoForm({
            cliente: "",
            tipoDeServicioContrato: "",
            tipoDeDocumento: "",
          });
        }
      }
      if (formik.values.submotivo === 2156275694 || formik.values.submotivo === 2736088215) {
        setSubmotivoSelected("excepcion");
        setContratoForm(null);
        if (!excepcionForm) {
          setExcepcionForm({
            tipoDeServicioExcepcion: "",
            tipoDeDocumento: "",
          });
        }
      }
    } else {
      setContratoForm(null);
      setExcepcionForm(null);
      setSubmotivoSelected(null);
    }
  }, [formik]);

  const handleDownloadTemplateFile = async (submotivoId) => {
    setIsSubmotivoFileLoading(true);

    try {
      const { result } = await getSubmotivoFile({ submotivoId });

      if (result && result.length > 0 && result[0]) {
        try {
          const file = { FileRels: result[0] };

          await handleClickFile(file);
        } catch (error) {
          handleErrors(error, toast.error);
        }
      } else {
        toast.success("Este submotivo no requiere un template especifico");
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }

    setIsSubmotivoFileLoading(false);
  };

  return (
    <>
      <BlurSpinner isLoading={formik.isSubmitting || isLoadingEditor || spinnerState}>
        <form onSubmit={formik.handleSubmit} style={{ fontFamily: "Nunito" }}>
          <Row>
            <Col className="mb-4">
              <div className="h-100">
                <div>
                  <h5 style={{ fontWeight: "bold" }}>Cargue los datos del nuevo ticket</h5>
                  En base al destinatario del ticket, por favor completar el formulario seleccionando las opciones correspondientes
                </div>

                <div>
                  <CreateTicketInBehalf createInBehalf={userToCreateTicket} formik={formik} setisOnBehalf={handleSetOnBehalf} isOnBehalf={isOnBehalf} />
                </div>
                <div>
                  {/* selects */}
                  <div>
                    <TicketZoneSelector formik={formik} mounted={ticketZoneMount} setDisclaimer={setDisclaimer} grid />
                    <FormGroup>
                      <Form className="p-absolute" style={{ height: "0px", width: "0px", overflow: "hidden" }}>
                        <input
                          id="upfile"
                          type="file"
                          onChange={handleConfirmSelectedFiles}
                          multiple
                          accept="image/jpeg,image/gif,image/png,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        />
                      </Form>
                    </FormGroup>
                  </div>

                  {submotivoSelected === "contrato" && (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                        justifyItems: "stretch",
                        alignItems: "start",
                        gap: "1rem",
                        marginBottom: "2rem",
                        borderTop: "1px solid #ccc",
                        paddingTop: "1rem",
                      }}
                    >
                      <div>
                        <CustomLabel htmlFor="cliente" className="w-100" fontSize="18px" fontWeight="800">
                          Cliente
                        </CustomLabel>
                        <InputText
                          border="solid 1px #ccc"
                          height="40px"
                          className={`w-100 ${formik.errors.asignacion2 && formik.touched.asignacion2 ? "error-field" : ""}`}
                          id="cliente"
                          name="cliente"
                          onChange={(e) => {
                            if (!e.target.value) {
                              setContratoForm({ ...contratoForm, cliente: null });
                              return;
                            }
                            setContratoForm({ ...contratoForm, cliente: e.target.value });
                          }}
                        />
                        {messageError.error && messageError.cliente && formik.touched.cliente && <ErrorFeedback>{messageError.cliente}</ErrorFeedback>}
                      </div>
                      <div>
                        <CustomLabel htmlFor="tipoDeServicioContrato" className="w-100" fontSize="18px" fontWeight="800">
                          Tipo de Servicio
                        </CustomLabel>
                        <SelectV2
                          height="40px"
                          id="tipoDeServicioContrato"
                          name="tipoDeServicioContrato"
                          onChange={handleReactSelectChange}
                          value={
                            contratoForm && contratoForm.tipoDeServicio
                              ? tipoDeServiciosContratosOptions.find((item) => item.value === contratoForm.tipoDeServicio)
                              : null
                          }
                          placeholder="Seleccionar..."
                          isLoading={isLoadingCategories}
                          options={tipoDeServiciosContratosOptions}
                        />
                        {messageError.error && messageError.tipoDeServicioContrato && formik.touched.tipoDeServicioContrato && (
                          <ErrorFeedback>{messageError.tipoDeServicioContrato}</ErrorFeedback>
                        )}
                      </div>

                      <div>
                        <CustomLabel htmlFor="regionContrato" className="w-100" fontSize="18px" fontWeight="800">
                          Region
                        </CustomLabel>
                        <SelectV2
                          height="40px"
                          id="regionContrato"
                          name="regionContrato"
                          onChange={handleReactSelectChange}
                          value={regionValue && regionValue.value && helperRegionSucursal.regionesOptions.find((option) => option.value === regionValue.value)}
                          placeholder="Todo"
                          isClearable
                          isLoading={isLoadingRegiones}
                          isDisabled={isLoadingRegiones || helperRegionSucursal.disableRegionSucursal}
                          options={helperRegionSucursal.regionesOptions}
                        />
                      </div>
                      <div>
                        <CustomLabel htmlFor="sucursalContrato" className="w-100" fontSize="18px" fontWeight="800">
                          Sucursal
                        </CustomLabel>
                        <SelectV2
                          height="40px"
                          id="sucursalContrato"
                          name="sucursalContrato"
                          onChange={handleReactSelectChange}
                          value={
                            contratoForm && contratoForm.sucursal ? helperRegionSucursal.casasAndSucusOptions.find((item) => item.value === contratoForm.sucursal) : null
                          }
                          placeholder="Todo"
                          isClearable
                          isLoading={isLoadingSucursales}
                          isDisabled={isLoadingSucursales || helperRegionSucursal.disableRegionSucursal}
                          options={helperRegionSucursal.casasAndSucusOptions}
                        />
                        {messageError.error && messageError.sucursalContrato && formik.touched.sucursalContrato && (
                          <ErrorFeedback>{messageError.sucursalContrato}</ErrorFeedback>
                        )}
                      </div>

                      <div>
                        <CustomLabel htmlFor="tipoDeDocumento" className="w-100" fontSize="18px" fontWeight="800">
                          Tipo de Documento
                        </CustomLabel>
                        <SelectV2
                          height="40px"
                          id="tipoDeDocumento"
                          name="tipoDeDocumento"
                          onChange={handleReactSelectChange}
                          value={
                            contratoForm && contratoForm.tipoDeDocumento ? tiposDeDocumentosOptions.find((item) => item.value === contratoForm.tipoDeDocumento) : null
                          }
                          placeholder="Seleccionar..."
                          isLoading={isLoadingCategories}
                          options={tiposDeDocumentosOptions}
                        />
                        {messageError.error && messageError.tipoDeDocumento && formik.touched.tipoDeDocumento && (
                          <ErrorFeedback>{messageError.tipoDeDocumento}</ErrorFeedback>
                        )}
                      </div>
                    </div>
                  )}
                  {submotivoSelected === "excepcion" && (
                    <>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                          justifyItems: "stretch",
                          alignItems: "start",
                          gap: "1rem",
                          marginBottom: "1rem",
                          borderTop: "1px solid #ccc",
                          paddingTop: "1rem",
                        }}
                      >
                        <div>
                          <CustomLabel htmlFor="tipoDeServicioExcepcion" className="w-100" fontSize="18px" fontWeight="800">
                            Tipo de Servicio
                          </CustomLabel>
                          <SelectV2
                            height="40px"
                            id="tipoDeServicioExcepcion"
                            name="tipoDeServicioExcepcion"
                            onChange={handleReactSelectChange}
                            value={
                              excepcionForm && excepcionForm.tipoDeServicio
                                ? tipoDeServiciosExcepcionOptions.find((item) => item.value === excepcionForm.tipoDeServicio)
                                : null
                            }
                            placeholder="Seleccionar..."
                            isLoading={isLoadingCategories}
                            options={tipoDeServiciosExcepcionOptions}
                          />
                          {messageError.error && messageError.tipoDeServicioExcepcion && formik.touched.tipoDeServicioExcepcion && (
                            <ErrorFeedback>{messageError.tipoDeServicioExcepcion}</ErrorFeedback>
                          )}
                        </div>
                        <div>
                          <CustomLabel htmlFor="motivoDeExcepcion" className="w-100" fontSize="18px" fontWeight="800">
                            Motivo de Excepción
                          </CustomLabel>
                          <SelectV2
                            height="40px"
                            id="motivoDeExcepcion"
                            name="motivoDeExcepcion"
                            onChange={handleReactSelectChange}
                            value={
                              excepcionForm && excepcionForm.motivoDeExcepcion
                                ? motivosDeExcepcionOptions.find((item) => item.value === excepcionForm.motivoDeExcepcion)
                                : null
                            }
                            placeholder="Seleccionar..."
                            isLoading={isLoadingCategories}
                            options={motivosDeExcepcionOptions}
                          />
                          {messageError.error && messageError.motivoDeExcepcion && formik.touched.motivoDeExcepcion && (
                            <ErrorFeedback>{messageError.motivoDeExcepcion}</ErrorFeedback>
                          )}
                        </div>

                        <div>
                          <CustomLabel htmlFor="regionExcepcion" className="w-100" fontSize="18px" fontWeight="800">
                            Region
                          </CustomLabel>
                          <SelectV2
                            height="40px"
                            id="regionExcepcion"
                            name="regionExcepcion"
                            onChange={handleReactSelectChange}
                            value={regionValue && regionValue.value && helperRegionSucursal.regionesOptions.find((option) => option.value === regionValue.value)}
                            placeholder="Todo"
                            isClearable
                            isLoading={isLoadingRegiones}
                            isDisabled={isLoadingRegiones || helperRegionSucursal.disableRegionSucursal}
                            options={helperRegionSucursal.regionesOptions}
                          />
                        </div>
                        <div>
                          <CustomLabel htmlFor="sucursalExcepcion" className="w-100" fontSize="18px" fontWeight="800">
                            Sucursal
                          </CustomLabel>
                          <SelectV2
                            height="40px"
                            id="sucursalExcepcion"
                            name="sucursalExcepcion"
                            onChange={handleReactSelectChange}
                            value={
                              excepcionForm && excepcionForm.sucursal
                                ? helperRegionSucursal.casasAndSucusOptions.find((item) => item.value === excepcionForm.sucursal)
                                : null
                            }
                            placeholder="Todo"
                            isClearable
                            isLoading={isLoadingSucursales}
                            isDisabled={isLoadingSucursales || helperRegionSucursal.disableRegionSucursal}
                            options={helperRegionSucursal.casasAndSucusOptions}
                          />
                          {messageError.error && messageError.sucursalExcepcion && formik.touched.sucursalExcepcion && (
                            <ErrorFeedback>{messageError.sucursalExcepcion}</ErrorFeedback>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {disclaimer !== "" ? <AvisoContainer color="#7b7979">{disclaimer}</AvisoContainer> : <></>}

                  {/* ckeditor */}
                  <TextContainer>
                    <InputTextAreaEditorContainer className="mb-1 custom-scrollbar" style={{ maxHeight: "500px", margin: "10px", overflowY: "scroll" }}>
                      <CKEditor
                        editor={ClassicEditor}
                        config={{
                          removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                        }}
                        data={formik.values.solicitud}
                        onReady={() => setIsLoadingEditor(false)}
                        onChange={(event, editor) => formik.setFieldValue("solicitud", editor.getData())}
                        onBlur={() => formik.setFieldTouched("solicitud")}
                      />
                      {formik.errors.solicitud && formik.touched.solicitud && <div className="input-feedback">{formik.errors.solicitud}</div>}
                    </InputTextAreaEditorContainer>
                    <div>
                      <FileUploader
                        showIcon={false}
                        style={{ margin: "10px" }}
                        files={Array.from(selectedFiles)}
                        onFilesChange={(files) => setSelectedFiles(files)}
                        acceptedFiles=".jfif,.pjp,.jpg,.pjpeg,.jpeg,.gif,.png,.pdf,.xlsx,.xls,.dot,.doc,.docx"
                        disabled={false}
                      />
                      <CustomToolBarGroup>
                        <div className="d-flex justify-content-between">
                          {formik && formik.values.submotivo && (
                            <StyledSpinnerButton
                              style={{ minWidth: "200px", color: "#fff", background: "#f0292a", marginLeft: "10px" }}
                              type="button"
                              isLoading={isSubmotivoFileLoading}
                              onClick={() => handleDownloadTemplateFile(formik.values.submotivo)}
                            >
                              Descargar template <Download size="18" />
                            </StyledSpinnerButton>
                          )}
                        </div>

                        <div className="d-flex justify-content-end">
                          <ButtonSecondaryV2 type="button" onClick={() => toggle()} className="ml-2" color="secondary">
                            Cancelar
                          </ButtonSecondaryV2>
                          <ButtonPrimary type="submit">Enviar</ButtonPrimary>
                        </div>
                      </CustomToolBarGroup>
                    </div>
                  </TextContainer>
                </div>
              </div>
            </Col>
          </Row>
        </form>
      </BlurSpinner>
    </>
  );
};

export default withRouter(TicketingNew);
